module.exports = __webpack_public_path__ + "img/TaskMan.107e0d09.png";